import { carleadCreationGetInitialProps } from '@wkda/carlead-creation-components';
import {
  BaseConversationalLeadPage,
  CarleadHIWWhyChooseWkdaFaq,
} from '@wkda/marketing-components';
import { defaultFlowWithoutConsent } from '@wkda/conversational-carlead';

function CarleadCreation() {
  return (
    <BaseConversationalLeadPage
      form={defaultFlowWithoutConsent}
      content={CarleadHIWWhyChooseWkdaFaq}
      showTrustPilot={true}
    />
  );
}

CarleadCreation.getInitialProps = carleadCreationGetInitialProps;

export default CarleadCreation;
